import _toConsumableArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
export var WIDGET_KEY = 'tx-auth-widget';
var TOKEN_KEY = 'token';
var TOKEN_RECEIVE_TIME_KEY = 'token-receive-time';
var LOCAL_ID_KEY = 'local-id';
var LAST_LOGIN_APPNAME_KEY = 'last-login-appname';
var TOKEN_REGEXP = /token:([^:]*):?([^:]*)/;
export var buildStorageKey = function buildStorageKey(_ref) {
  var env = _ref.env,
      widgetKey = _ref.widgetKey,
      itemKey = _ref.itemKey,
      appName = _ref.appName,
      params = _ref.params;
  return [env === 'prod' ? null : env, widgetKey || WIDGET_KEY, itemKey, appName].concat(_toConsumableArray(params || [])).filter(function (f) {
    return !!f;
  }).join(':');
};
export var buildScopeKey = function buildScopeKey(scope) {
  return "".concat(scope.content).concat(Number(scope.readonly)).concat(Number(scope.restricted));
};
export var isTokenKey = function isTokenKey(env, scope) {
  var widgetKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : WIDGET_KEY;
  return function (key) {
    if (env === 'prod' && key.startsWith(env) || env !== 'prod' && !key.startsWith(env)) {
      return false;
    }

    if (scope && !key.includes(buildScopeKey(scope))) {
      return false;
    }

    return key.includes("".concat(widgetKey, ":").concat(TOKEN_KEY, ":"));
  };
};
export var buildLocalIdKey = function buildLocalIdKey(appName) {
  var widgetKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WIDGET_KEY;
  return [widgetKey, LOCAL_ID_KEY, appName].join(':');
}; // TODO remove after removing iframe

export var buildLastLoginAppNameKey = function buildLastLoginAppNameKey(env) {
  var widgetKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WIDGET_KEY;
  return buildStorageKey({
    env: env,
    widgetKey: widgetKey,
    itemKey: LAST_LOGIN_APPNAME_KEY
  });
};
export var buildTokenKey = function buildTokenKey(env, appName, provider, scope) {
  var widgetKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : WIDGET_KEY;
  return buildStorageKey({
    env: env,
    widgetKey: widgetKey,
    itemKey: TOKEN_KEY,
    appName: appName,
    params: [provider, scope && buildScopeKey(scope)]
  });
};
export var buildTokenReceiveTimeKey = function buildTokenReceiveTimeKey(env, appName, provider, scope) {
  var widgetKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : WIDGET_KEY;
  return buildStorageKey({
    env: env,
    widgetKey: widgetKey,
    itemKey: TOKEN_RECEIVE_TIME_KEY,
    appName: appName,
    params: [provider, scope && buildScopeKey(scope)]
  });
};
export var getAppNameByTokenKey = function getAppNameByTokenKey(key) {
  var _a;

  return (_a = key.match(TOKEN_REGEXP)) === null || _a === void 0 ? void 0 : _a[1];
};
export var getProviderByTokenKey = function getProviderByTokenKey(key) {
  var _a;

  return (_a = key.match(TOKEN_REGEXP)) === null || _a === void 0 ? void 0 : _a[2];
};